import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation CreateWorkspaceProject(
    $customerId: ID!
    $type: String!
    $name: String
    $briefType: String!
    $workspaceId: ID!
    $briefId: ID
    $url: String
    $projectFolderId: ID
    $generationTool: GenerationToolEnum
    $customerMultiPromptTemplateId: ID
  ) {
    createWorkspaceProject(
      customerId: $customerId
      type: $type
      name: $name
      briefType: $briefType
      workspaceId: $workspaceId
      briefId: $briefId
      url: $url
      projectFolderId: $projectFolderId
      generationTool: $generationTool
      customerMultiPromptTemplateId: $customerMultiPromptTemplateId
    ) {
      id
    }
  }
`;

export const createProject = ({
  customerId,
  projectType,
  brief,
  briefId,
  workspaceId,
  url,
  projectFolderId,
  name,
  generationTool,
  customerMultiPromptTemplateId,
}) => {
  // Common params, present in all project/brief types
  const variables = {
    customerId,
    type: projectType,
    briefType: brief.type,
    workspaceId,
    briefId,
    projectFolderId,
    name,
    url,
    generationTool,
    customerMultiPromptTemplateId,
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
  }).then(({ data }) => getSingleProp(data));
};
